import React, { Component } from "react";
import { Row, Col } from "cakemail-ui-components/lib/react";
import { Translate } from "react-redux-i18n";
import SettingsList from "./SettingsList";
import AccountUsage from "./AccountUsage";
import { connect } from "react-redux";
import { getUrlsBasedOnLanguage } from "assets/js/utils/languages";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import { isPartner, isPreviewingBrand } from "utils/apiUtils";
import { connectToZendeskSupport } from "assets/js/services/hiddenService";
import fetchRoute from "utils/routes";
import { openTagManagerOverlay } from "assets/js/components/tagManager/TagManagerOverlay";

class SettingsCard extends Component {
	constructor(props) {
		super(props);

		this.handleClickOutside = this.handleClickOutside.bind(this);
		this.setRef = this.setRef.bind(this);
		this.redirectToPath = this.redirectToPath.bind(this);

		let list = [
			{
				path: "/account",
				title: <Translate value="app-menu-list-account" />,
			},
			{
				path: "/account/users/" + this.props.user.id,
				title: <Translate value="app-menu-list-profile" />,
			},
			{
				path: "/account/users",
				title: <Translate value="app-menu-list-users" />,
			},
			{
				path: "/account/senders",
				title: <Translate value="app-account-settings-sender_emails" />,
			},
			//TODO: Add this when Suppression list will be created
			/*{
									path: "/account/suppressed-emails",
									title: <Translate value="app-menu-list-do_not_email"/>
							},*/
			//TODO: Add this when Billing will be created
			/*{
									path: "/account/invoices",
									title: <Translate value="app-menu-list-billing"/>
							},*/
			{
				action: openTagManagerOverlay,
				path: "",
				title: <Translate value="app-menu-tag-library" />,
			},
			{
				action: props.logOut,
				path: "",
				title: <Translate value="app-menu-list-sign_out" />,
			},
		];

		list.splice(3, 0, {
			path: fetchRoute("brand"),
			title: <Translate value="app-menu-list-brand" />,
			disabled:
				isPreviewingBrand() ||
				(this.props.userBrand?.client_config?.brand_repo?.url &&
					this.props.userBrandSDK == null),
		});

		let helpLink = {
			type: "link",
			title: <Translate value="app-menu-list-help" />,
			target: "_blank",
		};

		if (this.props.zendeskLoginAccess) {
			helpLink.action = () => {
				connectToZendeskSupport();
			};
			list.unshift(0, 0, helpLink);
		} else if (this.props.helpUrl) {
			helpLink.path = this.props.helpUrl;
			list.unshift(0, 0, helpLink);
		}

		this.state = {
			list: list,
		};
	}
	componentDidMount() {
		document.addEventListener("mousedown", this.handleClickOutside);
	}

	componentWillUnmount() {
		document.removeEventListener("mousedown", this.handleClickOutside);
	}

	componentDidUpdate(prevProps) {
		if (prevProps.location.pathname !== this.props.location.pathname) {
			this.props.changeStatus();
		}
	}

	handleClickOutside(event) {
		if (
			this.wrapperRef &&
			!this.wrapperRef.contains(event.target) &&
			this.props.settingsRef &&
			!this.props.settingsRef.contains(event.target)
		) {
			this.props.changeStatus();
		}
	}

	setRef(node) {
		this.wrapperRef = node;
	}

	redirectToPath(item) {
		if (item.action) {
			item.action();
			return;
		}

		if (item.type === "link") {
			if (item.target) {
				window.open(item.path, item.target);
			} else {
				window.location.href = item.path;
			}
		} else {
			this.props.history.push(item.path);
		}
	}

	render() {
		let list = this.state.list.map((element, index) => {
			return (
				<div key={index} onClick={() => this.redirectToPath(element)}>
					<SettingsList
						{...this.props}
						listItem={element}
						key={`settings-item-${index}`}
					/>
				</div>
			);
		});

		return (
			<div className="settings-card" ref={this.setRef}>
				<Row className="settings-card-row">
					<Col xs={8} className="account-usage-content">
						<AccountUsage {...this.props} />
					</Col>
					<Col xs={4} className="settings-list">
						{list}
					</Col>
				</Row>
			</div>
		);
	}
}

SettingsCard.propTypes = {
	history: PropTypes.object,
	changeStatus: PropTypes.func,
	settingsRef: PropTypes.object,
	location: PropTypes.object,
	logOut: PropTypes.func,
	helpUrl: PropTypes.string,
	user: PropTypes.object,
	zendeskLoginAccess: PropTypes.bool,
	zendeskReturnTo: PropTypes.string,
	brandConfig: PropTypes.object,
	accountId: PropTypes.string,
	userBrand: PropTypes.object,
	userBrandSDK: PropTypes.object,
};

export default withRouter(
	connect((state) => {
		return {
			language: state.global.language,
			helpUrl: getUrlsBasedOnLanguage(
				state.brand?.url?.help_url,
				"help_url",
				state.global.language
			),
			zendeskLoginAccess: state?.brand?.client_config?.zendesk_config?.enabled,
			userBrand: state.userBrand,
			userBrandSDK: state.userBrandSDK,
			user: state.global.user,
			brandConfig: state.brand?.config,
			accountId: state.global.account?.id,
		};
	})(SettingsCard)
);
